/** 用户取货方式 */
export enum UserGetMode {
  delivery = 'delivery',
  pickup = 'pickup',
}

export const BundleVersion = Mach.env.bundleVersion === '0.0.1' ? '0.1.999' : Mach.env.bundleVersion;
